import React from "react";
import { Field } from "formik";
import ReactDatetime from "react-datetime";
import { InputGroupText, InputGroup } from "reactstrap";

export interface FormikDatetimeProps {
  name: string;
  timeFormat: boolean;
  placeholder: string;
  defaultValue: string;
}
// expecting YYYY-MM-DDTHH:MM:SS:0000Z
// returns MM/DD/YYYY
const formatFromIso = (isoStr: string) => {
  if (!isoStr) {
    return "";
  }
  const dt = isoStr.split("T")[0];
  return `${dt.split("-")[1]}/${dt.split("-")[2]}/${dt.split("-")[0]}`;
};
//
// tslint:disable:max-line-length
export default function FormikDatetime(props: FormikDatetimeProps) {
  return (
    <>
      <InputGroup className="date" id="datetimepicker">
        <Field name={props.name}>
          {({ form }: { field: any; form: any }) => (
            <ReactDatetime
              timeFormat={props.timeFormat}
              inputProps={{
                placeholder: props.placeholder,
              }}
              utc={true}
              onChange={(momentDtObj: any) => {
                // plugin will return the string input if the date is invalid otherwise a moment dt obj
                if (typeof momentDtObj === "string") {
                  return;
                }
                form.setFieldValue(props.name, momentDtObj.toISOString());
              }}
              defaultValue={formatFromIso(props.defaultValue)}
            />
          )}
        </Field>
        <InputGroupText>
          <span className="glyphicon glyphicon-calendar">
            <i aria-hidden={true} className="fa fa-calendar" />
          </span>
        </InputGroupText>
      </InputGroup>
    </>
  );
}
